import React, { useState, useEffect } from "react";

// Libraries & Packages
import AnimatedCursor from "react-animated-cursor";

// State
import { useMenuStore } from "utils/state/Store";

// Utils
import ThemeUtils from "utils/styles/Theme";

function MousePointer() {
  // State
  const { toggleMenu } = useMenuStore();
  const [color, setColor] = useState(ThemeUtils.globalColors.white);

  // Effect
  useEffect(() => {
    setColor(
      toggleMenu ? ThemeUtils.globalColors.black : ThemeUtils.globalColors.white
    );
  }, [toggleMenu]);

  return (
    <AnimatedCursor
      key={color}
      innerSize={4}
      outerSize={48}
      color={color}
      outerAlpha={0.05}
      innerScale={1}
      outerScale={1.75}
      outerStyle={{
        border: `1px solid rgba(${color})`,
        color: "transparent",
      }}
      showSystemCursor={true}
    />
  );
}

export default MousePointer;
